import Vue from 'vue'
import * as enums from '@/enums'

import '@/helper/publicPath'
import '@/plugins/exceptionHandler'
import * as dayjs from '@/plugins/dayjs'
import '@/plugins/api'
import '@/plugins/modal'

import App from '@/App.vue'
import store from '@/store'

Vue.prototype.$enum = enums

new Vue({
  store,
  mounted() {
    dayjs.setDayjsLocale(this.$dayjs)
  },
  render: (h) => h(App),
}).$mount('#innso-chat')
